import externalVideo from "./lazyFunctions/externalVideo";
import counterBlock from "./lazyFunctions/counterBlock";

export default function(el) {
    if (el.classList.contains("ev")) externalVideo(el);

    if (el.classList.contains("counter-block")) counterBlock(el);

    el.classList.remove("e-in");
    el.classList.add("scroll-in-active");
}
